"use client";

import * as React from "react";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "ui/components/breadcrumb";
import { useLocation, useMatches } from "react-router-dom";

import { Link } from "react-router-dom";
import { useBreadcrumbData } from "components/breadcrumb/hooks/useBreadcrumbData";

const FOLDERS_BASE_PATH = "/organization/folders";

export function BreadcrumbNav() {
  const matches = useMatches();
  const data = useBreadcrumbData();

  let crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb) && match.pathname !== "/")
    .map((match) => {
      const crumb = match.handle.crumb;
      const path = match.pathname;
      return {
        crumbLabel: typeof crumb === "function" ? crumb(data) : crumb,
        pathname: path,
      };
    });

  // Expand folder * route into full hierarchy: Folders > Parent1 > Parent2 > Current
  const lastCrumb = crumbs[crumbs.length - 1];
  const isFolderSplat =
    lastCrumb?.pathname?.startsWith(`${FOLDERS_BASE_PATH}/`) &&
    lastCrumb.pathname !== FOLDERS_BASE_PATH;
  const folderPathWithNames = data.folderPathWithNames ?? [];

  if (isFolderSplat && folderPathWithNames.length > 0) {
    const folderCrumbs = folderPathWithNames.map((segment, i) => {
      const pathSegment = folderPathWithNames
        .slice(0, i + 1)
        .map((f) => f.id)
        .join("/");
      return {
        crumbLabel: data.isLoading.folder ? "Loading..." : segment.name,
        pathname: `${FOLDERS_BASE_PATH}/${pathSegment}`,
      };
    });
    crumbs = [...crumbs.slice(0, -1), ...folderCrumbs];
  }

  if (crumbs.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <React.Fragment key={crumb.pathname}>
              {index > 0 && <BreadcrumbSeparator className="hidden md:block" />}
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{crumb.crumbLabel}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.pathname}>{crumb.crumbLabel}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
